export const BLOCKED_SSM_ADDRESSES = [
  {
    addressLine1: '169 Madison Ave Ste 11382',
    city: 'New York',
    state: 'NY',
    zipCode: '10016',
  },
  {
    addressLine1: '3229 Greenpoint Ave PMB 255',
    city: 'Long Island City',
    state: 'NY',
    zipCode: '11101',
  },
];
